import { AxiosPromise, CancelToken } from 'axios';
import { ListContact, ListContactsRequest } from '../sic-lib/types/ListContact';
import { UpdateListRequest } from '../sic-lib/types/Lists';
import { apiInstance as instance } from './';

let requestLists_cancel: any;

/**
 * Makes a HTTP request for contacts within an existing group or those specified within the provided array
 * @param data
 * @param cancelToken
 */
export function requestListContacts(
    data: ListContactsRequest,
    cancelToken: CancelToken,
): AxiosPromise<ListContact[]> {
    return instance.post('/contacts/lists/names', data, {
        cancelToken: cancelToken,
        headers: {
            'Content-Type': 'application/json',
        },
    });
}

/**
 * Makes a HTTP request to update properties of an existing list
 * @param data
 * @param cancelToken
 */
export function requestUpdateList(
    data: UpdateListRequest,
    cancelToken: CancelToken,
): AxiosPromise<unknown> {
    return instance.put('/contacts/lists', data, {
        cancelToken: cancelToken,
        headers: {
            'Contact-Type': 'application/json',
        },
    });
}

/**
 * Makes a HTTP request to add contact(s) to an existing contact group list
 * @param listId
 * @param data
 * @param cancelToken
 */
export function requestAddListContacts(
    listId: number,
    data: number[],
    cancelToken: CancelToken,
): AxiosPromise<unknown> {
    return instance.put(`/contacts/lists/${listId}/items`, data, {
        cancelToken: cancelToken,
        headers: {
            'Content-Type': 'application/json',
        },
    });
}

/**
 * Makes a HTTP request to remove contact(s) from an existing contact group list
 * @param listId
 * @param data
 * @param cancelToken
 */
export function requestRemoveListContacts(
    listId: number,
    data: number[],
    cancelToken: CancelToken,
): AxiosPromise<unknown> {
    return instance.delete(`/contacts/lists/${listId}/items`, {
        cancelToken: cancelToken,
        data: data,
        headers: {
            'Content-Type': 'application/json',
        },
    });
}
